<script>
import Button from "@/components/atoms/button";

export default {
  components: {
    Button
  },
  props: {
    service: {
      type: Object,
      required: false
    },
    raisonsImpossible: {
      type: Array,
      required: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div
    class="c-shipping-method-multi-service"
    :class="disabled && 'u-bgcolor-grey-5'"
  >
    <Button
      full-width
      align="left"
      v-bind="removeClassAndStyleFromAttrs($attrs)"
      :disabled="disabled"
      class="u-text-left"
    >
      <div class="u-block">
        {{ service.description }} <br>
        {{ service.adresse }} <br>
        {{ service.details }}
      </div>
    </Button>
    <div
      v-if="raisonsImpossible && raisonsImpossible"
      class="u-font-15 u-mt-sm"
    >
      <div>
        <p
          v-for="(raison, index) in raisonsImpossible"
          :key="`raison-service-${index}-${raison.type_raison}`"
        >
          {{ raison.raison }}
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.c-shipping-method-multi-service {
  border-radius: radius(md);
  border: 1px solid color(grey-4);
  padding: spacing(xs);
}
</style>
